module.exports = __webpack_public_path__ + "assets/TrapezoidCutDetailed.5423828d1cf0640aff5e25c6ccb22017.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TrapezoidCutDetailed.png
// module id = 592
// module chunks = 0